<template>
  <div>
    <v-card class="pt-3 pb-3 mb-3">
      <v-row>
        <v-card-title>
          <h2 class="text-xl">Utms</h2>
        </v-card-title>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            class="ml-6 mr-6"
            v-model="search"
            append-icon="mdi-magnify"
            label="Recherche"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            class="ml-6 mr-6"
            :items="items"
            :headers="headers"
            :search="search"
          >
            <template v-slot:item.acqui_platform_id="{ item }">
              <span>
                {{ getPlatformName(item.acqui_platform_id) }}
              </span>
            </template>
            <template v-slot:[`item.source`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="truncate-cell" v-bind="attrs" v-on="on">
                    {{ item.source }}
                  </div>
                </template>
                <span>{{ item.source }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.edit="{ item }">
              <div>
                <v-btn
                  class="mx-2"
                  elevation="0"
                  fab
                  small
                  @click="editUtm(item)"
                >
                  <v-icon color="primary">
                    {{ icons.mdiPencil }}
                  </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  elevation="0"
                  fab
                  small
                  @click="deleteUtm(item)"
                >
                  <v-icon color="secondary">
                    {{ icons.mdiTrashCan }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="utmDialog" max-width="600px">
      <v-card>
        <v-card-title>Modifier l'utm</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="utm.source"
                label="source"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="utm.acqui_platform_id"
                :items="platforms"
                item-text="name"
                item-value="id"
                label="Plateformes"
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="utm.campaign"
                label="Campaign"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="updateUtm">Enregistrer</v-btn>
          <v-btn color="secondary" @click="cancelUtm">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.truncate-cell {
  max-width: 150px; /* Limite la largeur de la cellule */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer; /* Indique que l'utilisateur peut interagir */
}
</style>

<script>
import DagInfo from "@/components/common/menus/DagInfo";
import useAxios from "@/hooks/useAxios";
import debounce from "lodash/debounce";
import { mdiPencil, mdiTrashCan } from "@mdi/js";

export default {
  name: "dailyReportUtmTable",
  components: {},

  data() {
    return {
      search: "",
      items: [],
      headers: [
        { text: "Platform", value: "acqui_platform_id" },
        { text: "Source", value: "source" },
        { text: "Campaign", value: "campaign" },
        { text: "Actions", value: "edit", sortable: false },
      ],
      icons: {
        mdiPencil,
        mdiTrashCan,
      },
      utmDialog: false,
      utm: {
        id: "",
        source: "",
        campaign: "",
        acqui_platform_id: "",
      },
      platforms: [],
    };
  },

  setup() {
    const { axiosGet, axiosPost, axiosPut, axiosDelete, isLoading } =
      useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
      axiosPut,
      axiosDelete,
    };
  },

  methods: {
    debouncedUpdateData: debounce(async function () {
      await this.getData();
    }, 500),
    getPlatformName(platformId) {
      const platform = this.platforms.find((p) => p.id === platformId);
      return platform ? platform.name : "Non défini"; // Retourne "Non défini" si aucune correspondance
    },
    async getPlatforms() {
      const response = await this.axiosGet("/acquisition/platform/");
      this.platforms = response.data;
      this.$store.commit("acquisition/setPlatforms", this.platforms);
    },
    async getData() {
      const response = await this.axiosGet("/acquisition/utm/");
      this.items = response.data;
    },
    async cancelUtm() {
      (this.utm = {
        id: "",
        source: "",
        campaign: "",
        acqui_platform_id: "",
      }),
        (this.utmDialog = false);
      this.getData();
    },
    async editUtm(item) {
      this.utm = item;
      this.utmDialog = true;
    },
    async updateUtm() {
      if (this.utm.campaign === "") {
        this.utm.campaign = "NA";
      }
      const utm = {
        source: this.utm.source,
        acqui_platform_id: this.utm.acqui_platform_id,
        campaign: this.utm.campaign,
      };
      try {
        await this.axiosPut(`/acquisition/utm/${this.utm.id}`, utm);
      } catch (error) {
        console.error("Error saving UTM:", error);
        alert(
          "Erreur lors de la création de l'UTM, Vérifier l'inetégrité des données (doublons). Si les données sont intègres utilisez l'outil de report d'erreur"
        );
        this.cancelUtm();
      }
      this.utmDialog = false;
      this.getData();
    },
    async deleteUtm(item) {
      this.utm = item;
      const { status } = await this.axiosDelete(
        `/acquisition/utm/${this.utm.id}`
      );
      this.getData();
    },
  },

  async created() {
    await this.getPlatforms();
    await this.getData();
  },
  computed: {},
};
</script>
